import React, { useState } from "react";
// import ClaimCard from "./ClaimCard";
import IssueForm from "./IssueForm";
import { FormInput } from "../FormInput";
import SelectDropdown from "../MachCity/Dropdown/SelectDropdown";
import {
  ax_claim_claimCreatedIssue,
  ax_claim_claimFetch,
} from "../../api/warrantyForm";
import toast from "react-hot-toast";
import { ArrRefreshO } from "lovedicons/dist/arrO";
import WarrantyCard from "./Card";

function ClaimForm() {
  const initialClaimData = {
    name: "",
    frameNo: "",
    phone: "",
  };

  // Form States
  const [formData, setFormData] = useState({
    claimNo: "",
    natureOfIssue: "",
    otherIssue: "",
    purchaseDate: "",
    location: "",
    dealerName: "",
    images: null,
    imgArr: [],
    isTCChecked: false,
    createdFromBrand: "machcity",
  });

  const [showDealerField, setShowDealerField] = useState(false);
  const [selected, setSelected] = useState("");
  const [images, setImages] = useState([]);
  const [warrantyFormID, setWarrantyFormID] = useState("");
  const [claimData, setClaimData] = useState(initialClaimData);
  const [payloadData, setPaylaodData] = useState({});
  const [tableData, setTableData] = useState([]);
  const [selectedOption, setSelectedOption] = useState("Frame No"); // Default selected option
  // const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [isLoading, setIsLoading] = useState(false); // Loading state
  const [isFormEnabled, setIsFormEnabled] = useState(false); //For form visibility
  const [error, setError] = useState(""); // For error handling
  // const [showModal, setShowModal] = useState(false); // Modal visibility state
  // const dropdownRef = useRef(null);

  // const optionsList = ["Frame No", "Email ID", "Phone No"];

  // const handleSelected = (option) => {
  //   setSelectedOption(option);
  //   setIsDropdownOpen(false);
  // };

  // // Close dropdown if click happens outside of it
  // useEffect(() => {
  //   const handleClickOutside = (event) => {
  //     if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
  //       setIsDropdownOpen(false);
  //     }
  //   };

  //   document.addEventListener("mousedown", handleClickOutside);
  //   return () => {
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   };
  // }, []);

  // State to track the currently visible warranty card index
  const [currentIndex, setCurrentIndex] = useState(0);

  const [isSubmitted, setIsSubmitted] = useState(
    tableData?.length > 0 &&
      tableData[tableData.length - 1]?.warrStatus === "Pending"
      ? true
      : false
  );

  // Validation check before submitting
  const validateForm = () => {
    if (!selectedOption || !searchInput) {
      setError("Please select an option and enter a value to search.");
      return false;
    }
    setError("");
    return true;
  };

  const onHandleChange = (fieldName, e) => {
    const { value } = e.target;
    setClaimData((prev) => ({
      ...prev,
      [fieldName]: value,
    }));
  };
  const onPayloadDataChange = (fieldName, e) => {
    const { value } = e.target;
    setPaylaodData((prev) => {
      // Check if the fieldName is 'images'
      if (fieldName === "images") {
        // If it's images, add the value to the array
        return {
          ...prev,
          [fieldName]: [...(prev?.[fieldName] || []), value], // Clone and append
        };
      } else {
        // Otherwise, update the field as text
        return {
          ...prev,
          [fieldName]: value,
        };
      }
    });
  };

  const handleSearch = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return; // Stop submission if validation fails
    }

    setIsLoading(true); // Show loading spinner
    try {
      // const response = await fetch("/sample.json"); // Fetch data from sample.json
      // const data = await response.json();

      // // Filter based on selected option and search input

      // const filteredData = data.filter((item) => {
      //   if (selectedOption === "Frame No") {
      //     return item.frameNo === searchInput;
      //   }
      //   if (selectedOption === "Email ID") {
      //     return item.email === searchInput;
      //   }
      //   if (selectedOption === "Phone No") {
      //     return item.phone === searchInput;
      //   }
      //   if (selectedOption === "Name") {
      //     return (
      //       item.name && item.name.toLowerCase() === searchInput.toLowerCase()
      //     );
      //   }
      //   if (selectedOption === "Purchase Date") {
      //     return item.purchaseDate === searchInput;
      //   }
      //   if (selectedOption === "Dealer Name") {
      //     return item.dealerName && item.dealerName.toLowerCase() === searchInput.toLowerCase();
      //   }
      //   return false;
      // });

      // setSearchResults(filteredData); // Update search results

      const payload = {
        name: claimData?.name,
        frameNo: selectedOption === "Frame No" ? searchInput : "",
        phone: selectedOption === "Registered Phone No" ? searchInput : "",
      };
      // console.log("payload - " + JSON.stringify(payload));
      const ax_res = await ax_claim_claimFetch(payload);

      // console.log("ax_res hehheheh - " + JSON.stringify(ax_res));
      console.log("ax_res.data - " + JSON.stringify(ax_res.data));
      // console.log("ax_res.data.frameNo - " + JSON.stringify(ax_res.frameNo));
      if (ax_res?.data.code === 404 && !ax_res?.data.success) {
        setIsLoading(false);
        setIsFormEnabled(false);
        toast.error(ax_res?.data.description);
        // console.log("ax_res?.data.description -- " + ax_res?.data.description);
      }
      if (ax_res?.success === true) {
        setIsLoading(false);
        setIsFormEnabled(true);
        setIsSubmitted(false);
        setFormData({
          claimNo: "",
          natureOfIssue: "",
          otherIssue: "",
          purchaseDate: "",
          location: "",
          dealerName: "",
          images: null,
          imgArr: [],
          isTCChecked: false,
          createdFromBrand: "machcity",
      });

      setImages([]);
      setSelected("");
      setShowDealerField(false);


        setSearchResults(ax_res?.data);
        setWarrantyFormID(ax_res?.data?._id);
        // toast.success(ax_res?.description);
        // console.log("akbarsha - " + JSON.stringify(ax_res.data));
        // console.log(
        //   "akbarsha.frameNo - " + JSON.stringify(ax_res.data.frameNo)
        // );
        setPaylaodData({
          frameNo: ax_res?.data?.frameNo,
          wowNo: ax_res?.data?.wowNo,
          purchaseDate: ax_res?.data?.purchaseDate,
          dealerName: ax_res?.data?.dealerName,
          images: [], // Initialize images as an empty array
        });
        // setTableData(ax_res?.data?.issues);
        await fetchAllClaimCreatedIssue(ax_res?.data?._id);
        // if (ax_res.data.length > 0) {
        //   setPaylaodData({
        //     frameNo: ax_res?.data[0]?.frameNo,
        //     wowNo: ax_res?.data[0]?.wowNo,
        //     purchaseDate: ax_res?.data[0]?.purchaseDate,
        //     dealerName: ax_res?.data[0]?.dealerName,
        //   });
        //   setTableData(ax_res?.data[0]?.issues);
        // } else {
        //   setTableData(ax_res?.data);
        // }
        // setPaylaodData({
        //   frameNo: ax_res?.data ? ax_res?.data[0]?.frameNo : "",
        //   wowNo: ax_res?.data ? ax_res?.data[0]?.wowNo : "",
        //   purchaseDate: ax_res?.data ? ax_res?.data[0]?.purchaseDate : "",
        //   dealerName: ax_res?.data ? ax_res?.data[0]?.dealerName : "",
        // });
        // setTableData(ax_res?.data[0]?.issues);
        // ax_res.code
        // setApiResponse(ax_res.description);
      } else {
        setIsFormEnabled(false);
        setIsSubmitted(false);
        setSearchResults([]);
        // setFormData([]);
        // setShowModal(false);
      }

      //Enable the Issue form if there are results
      // if (filteredData.length > 0) {
      //   setIsFormEnabled(true);
      // } else {
      //   setIsFormEnabled(false);
      // }

      // //If there no recored popup message
      // if (filteredData.length === 0) {
      //   setShowModal(true);  // Set modal visibility when no results are found
      // } else {
      //   setShowModal(false); // Close modal if results are found
      // }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false); // Hide loading spinner
    }
  };

  const fetchAllClaimCreatedIssue = async (warrantyFormID) => {
    // console.log("warrantyFormID - " + JSON.stringify(warrantyFormID));

    const ax_allClaimCreatedIssue = await ax_claim_claimCreatedIssue(
      warrantyFormID
    );

    // console.log(
    //   "ax_allClaimCreatedIssue - " + JSON.stringify(ax_allClaimCreatedIssue)
    // );
    // console.log(
    //   "ax_createIssue - " + JSON.stringify(ax_createIssue.description)
    // );
    if (ax_allClaimCreatedIssue.success === true) {
      // toast.success(ax_allClaimCreatedIssue.description);
      setTableData(ax_allClaimCreatedIssue?.data);

      // setIsSubmitted(true);
    } else {
      // toast.error(ax_allClaimCreatedIssue.description);
      setTableData([]);
    }
  };

  // Function to handle next card
  const handleNext = () => {
    if (currentIndex < searchResults.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  // Function to handle previous card
  const handlePrevious = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };
  // console.log("tableData - " + JSON.stringify(tableData));
  // console.log("searchResults - " + JSON.stringify(searchResults));

  return (
    <section className="mt-6 px-4 bg-form-bg min-h-screen flex justify-center items-start">
      <div className="p-12 mt-6 mb-10 bg-white max-w-6xl w-full rounded-lg">
        <div className="mb-6 xl:-left-2 xl:top-64">
          <h1
            className="text-4xl text-black font-black"
            style={{ fontFamily: "var(--title-font)" }}
          >
            Warranty Claim
          </h1>
        </div>

        <section className="lg:m-auto xl:w-full flex lg:flex-row flex-col gap-6 xl:gap-8">
          {/* User details Fields */}
          <div className="w-full">
            {/* <form
              className="flex flex-col gap-4 text-black"
              onSubmit={handleSearch}
            >
              <div>
                <label htmlFor="name" className="block text-sm font-medium">
                  Name
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  placeholder="Enter your name"
                  className="mt-1 w-full p-3 bg-[#f1f1f1] text-black outline-none rounded-md focus:ring-2 focus:ring-orange-400 text-black"
                />
              </div>

              <div className="flex flex-row sm:flex-cols gap-4">
                <div className="w-2/3 relative" ref={dropdownRef}>
                  <label
                    htmlFor="dropdown"
                    className="block text-sm font-medium text-black mb-1"
                  >
                    Select
                  </label>
                  <div
                    className="flex justify-between items-center px-3 md:px-4 py-2 h-12 bg-[#f1f1f1] cursor-pointer rounded-md"
                    onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                  >
                    <span className="text-sm text-gray-600">
                      {selectedOption}
                    </span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className={`h-5 w-5 transform transition-transform ${
                        isDropdownOpen ? "rotate-180" : "rotate-0"
                      }`}
                      viewBox="0 0 20 20"
                      fill="text-gray-600"
                    >
                      <path
                        fillRule="evenodd"
                        d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 011.06 1.06l-4 4a.75.75 0 01-1.06 0l-4-4a.75.75 0 01.02-1.06z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>

                  {isDropdownOpen && (
                    <div className="absolute w-full bg-white mt-1 shadow-lg z-10">
                      {optionsList.map((option, index) => (
                        <div
                          key={index}
                          className={`px-4 py-2 text-md cursor-pointer ${
                            selectedOption === option
                              ? "bg-gray-200 text-black border-l-4 border-black"
                              : "hover:bg-gray-200 text-black"
                          }`}
                          onClick={() => handleSelected(option)}
                        >
                          {option}
                        </div>
                      ))}
                    </div>
                  )}
                </div> */}

            <form
              className="flex flex-col gap-4 text-black"
              onSubmit={handleSearch}
            >
              <FormInput
                label={"Name"}
                name={"name"}
                type={"text"}
                placeholder={"Enter your name"}
                value={claimData?.name}
                onChange={(e) => onHandleChange("name", e)}
              />

              <div className="flex flex-row sm:flex-cols gap-4">
                <SelectDropdown
                  selectedOption={selectedOption}
                  setSelectedOption={setSelectedOption}
                />

                <div className="w-full">
                  <label
                    htmlFor="searchNo"
                    className="block text-sm font-medium invisible"
                  >
                    Search
                  </label>
                  <input
                    type="text"
                    id="searchNo"
                    name="searchNo"
                    placeholder="Enter value"
                    value={searchInput}
                    onChange={(e) => setSearchInput(e.target.value)}
                    className="mt-1 w-full p-3 bg-[#f1f1f1] rounded-md outline-none focus:ring-2 focus:ring-orange-400 text-black"
                  />
                </div>
              </div>

              {/* Error Message */}
              {error && (
                <span className="text-red-500 text-sm mt-2">{error}</span>
              )}

              <div className="text-right">
                <button
                  type="submit"
                  className="w-fit mt-4 lg:mt-8 px-6 py-3 bg-black text-white font-semibold"
                >
                  {isLoading ? (
                    <div className="flex">
                      <ArrRefreshO className="mr-2 w-full h-6 animate-spin" />
                      <span>Searching...</span>
                    </div>
                  ) : (
                    "Search"
                  )}
                </button>
              </div>
            </form>
          </div>

          {/* Conditional rendering based on searchResults */}
          <div className="w-full min-h-64 bg-[#f1f1f1] flex flex-col gap-2 rounded-md justify-center items-center">
            {searchResults?.length === 0 ? (
              <div className="flex flex-col gap-2 justify-center items-center text-center">
                <svg
                  width="130"
                  height="80"
                  viewBox="0 0 364 198"
                  fill="none"
                  //   fill-opacity="0.6"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="1"
                    y="32"
                    width="321.284"
                    height="58"
                    rx="4"
                    stroke="black"
                    stroke-width="2"
                    stroke-dasharray="10 10"
                  />
                  <rect
                    x="1"
                    y="132"
                    width="321.284"
                    height="58"
                    rx="4"
                    stroke="black"
                    stroke-width="2"
                    stroke-dasharray="10 10"
                  />
                  <rect
                    x="40"
                    y="101"
                    width="323.284"
                    height="60"
                    rx="5"
                    fill="#2a2a2a"
                  />
                  <path
                    d="M322.496 23.5396C324.521 26.6309 325.916 30.0906 326.604 33.7213C327.291 37.3521 327.257 41.0826 326.503 44.7001C325.748 48.3175 324.289 51.7509 322.208 54.8044C320.127 57.8578 317.464 60.4714 314.373 62.4959C311.282 64.5205 307.822 65.9163 304.191 66.6038C300.561 67.2913 296.83 67.2569 293.213 66.5026C289.595 65.7483 286.162 64.2889 283.108 62.2077C280.055 60.1265 277.441 57.4643 275.417 54.373L298.956 38.9563L322.496 23.5396Z"
                    fill="#D64250"
                  />
                  <path
                    d="M33.8136 162.408L34.4888 189.261L10.8962 176.419L33.8136 162.408Z"
                    fill="#006AF6"
                  />
                  <path d="M66 122H204L186.5 140H66V122Z" fill="#666666" />
                  <circle cx="326" cy="131" r="12" fill="#F3DA00" />
                </svg>

                <h3 className="font-medium text-black">
                  Your warranty card will be displayed here.
                </h3>
                <span className="text-sm text-gray-400">
                  Enter your frame no, warranty no, or email ID to <br /> check
                  and claim your warranty card.
                </span>
              </div>
            ) : (
              <div>
                <WarrantyCard data={[searchResults]} />

                {searchResults.length > 1 && (
                  <div className="flex justify-between w-full">
                    <button
                      onClick={handlePrevious}
                      disabled={currentIndex === 0}
                      className="px-4 py-2 bg-[#30363e] text-white"
                    >
                      Previous
                    </button>
                    <button
                      onClick={handleNext}
                      disabled={currentIndex === searchResults.length - 1}
                      className="px-4 py-2 bg-[#30363e] text-white"
                    >
                      Next
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
        </section>

        {/* Modal for no results */}
        {/* {showModal && (
          <div className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-50">
            <div className="bg-white p-6 rounded-lg shadow-lg w-80">
              <h2 className="text-xl font-semibold text-center">
                No Results Found
              </h2>
              <p className="mt-2 text-center">
                The search didn't return any results. Please check the input and
                try again.
              </p>
              <div className="mt-4 text-center">
                <button
                  onClick={() => setShowModal(false)}
                  className="bg-black text-white py-2 px-4 rounded"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        )} */}

{isFormEnabled && (
          <IssueForm
          payloadData={payloadData}
            tableData={tableData}
            setTableData={setTableData}
            onPayloadDataChange={onPayloadDataChange}
            warrantyFormID={warrantyFormID}
            fetchAllClaimCreatedIssue={fetchAllClaimCreatedIssue}
            setSearchInput={setSearchInput}
            setClaimData={setClaimData}
            isSubmitted={isSubmitted}
            setIsSubmitted={setIsSubmitted}
            formData={formData}
            setFormData={setFormData}
            images={images}
            setImages={setImages}
            selected={selected}
            setSelected={setSelected}
            showDealerField={showDealerField}
            setShowDealerField={setShowDealerField}
        />
      )}
      </div>
    </section>
  );
}

export default ClaimForm;
